import moment from 'moment';
import companyBenefitModal from "../../../common/modals/companyBenefitModal/companyBenefitModal.component";
import leaveBenefitModal from "../../../common/modals/leaveBenefitModal/leaveBenefitModal.component";
import degreeModal from '../../../common/modals/degreeModal/degreeModal.component';
import indirectRateModal from '../../../common/modals/indirectRateModal/indirectRateModal.component';
import confirmModal from '../../../common/modals/ConfirmModal/confirmModal.component';

class SettingsController {

  constructor(toastr, $http, $rootScope, $stateParams, AuthenticationService, $scope, $uibModal, $timeout) {
    "ngInject";

    this.$http = $http;
    this.$rootScope = $rootScope;
    this.company = {};
    this.user = AuthenticationService.user;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$scope = $scope;
    this.$rootScope.logoPicTimeStamp = (new Date()).getTime();
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;
    this.indirectRates = [];
    this.logoExists = false;
    this.logoUrl = null;
    this.logoLoading = true;

    this.perDiemBaseUrl = $rootScope.apiHost + '/api/admin/per-diem-rates';
    this.perDiemSourceType = 'CONUS';
    this.perDiemNotes = '';
    this.perDiemSelectedFile = null;
    this.perDiemSelectedFileName = '';
    this.perDiemUploading = false;
    this.perDiemLoadingImports = false;
    this.perDiemImportsLoaded = false;
    this.perDiemImports = [];
    this.perDiemSearch = {
      city: '',
      state: '',
      country: '',
      zip: '',
      place: ''
    };
    this.perDiemLocationSearch = '';
    this.perDiemLocationOptions = {
      types: ['(regions)']
    };
    this.perDiemSearchResults = [];
    this.perDiemSearching = false;

    let self = this;


    this.userId = undefined;
    this.fromDate = undefined;
    this.endDate = undefined;
    this.oldChargeCode = undefined;
    this.newChargeCode = undefined;

    this.opened = {};
    this.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      self.opened[elementOpened] = !self.opened[elementOpened];
    };

    this.datePickerFormat = 'MMM dd, yyyy';
    this.dateOptions = {
      // dateDisabled: disabled,
      formatYear: 'yy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(1999,1,1),
      startingDay: 1
    };

    $http.get($rootScope.apiHost + "/api/admin/users/names", {withCredentials: true}).then(function (success) {
      self.employees = success.data;
    });

    $http.get($rootScope.apiHost+"/api/admin/chargecodes", {withCredentials: true}).then(function (success) {
      self.chargecodes = success.data;
    });

    $http.get($rootScope.apiHost+"/api/admin/companies/mycompany", {withCredentials: true}).then(function (success) {
      self.company = success.data;
      self.originalCompany = angular.copy(success.data);
      self.fileObject = document.getElementById("companyLogo");
      self.fileObject.addEventListener("change", function (event) {
        self.setPath();
      });
      // Load logo URL to check if it exists
      self.loadLogoUrl();
    });

    $http.get($rootScope.apiHost+"/api/admin/companies/1/socialsecurityrates", {withCredentials: true}).then(function (success) {
      self.socialSecurityRates = success.data;
    });

    $http.get($rootScope.apiHost+"/api/admin/companies/1/medicarerates", {withCredentials: true}).then(function (success) {
      self.medicareRates = success.data;
    });

    $http.get($rootScope.apiHost+"/api/admin/companies/1/futarates", {withCredentials: true}).then(function (success) {
      self.futaRates = success.data;
    });

    $http.get($rootScope.apiHost+"/api/admin/companies/1/sutarates", {withCredentials: true}).then(function (success) {
      self.sutaRates = success.data;
    });

    $http.get($rootScope.apiHost+"/api/admin/companies/1/degrees", {withCredentials: true}).then(function (success) {
      self.companyDegrees = success.data;
    });

    this.loadIndirectRates();

  }

  canViewCompanySettings() {
    return this.auth.hasPermission('PERM_VIEW_COMPANY_SETTINGS')
      || this.auth.hasPermission('PERM_MANAGE_COMPANY_SETTINGS');
  }

  canManageCompanySettings() {
    return this.auth.hasPermission('PERM_MANAGE_COMPANY_SETTINGS');
  }

  canManagePerDiemRates() {
    return this.auth.hasPermission('PERM_MANAGE_COMPANY_SETTINGS')
      || this.auth.hasPermission('PERM_MANAGE_EMPLOYEE_EXPENSES');
  }

  onPerDiemRatesTabSelected() {
    if (!this.perDiemImportsLoaded) {
      this.loadPerDiemImports();
    }
  }

  loadPerDiemImports() {
    this.perDiemLoadingImports = true;
    this.$http.get(this.perDiemBaseUrl + '/imports', { withCredentials: true }).then((success) => {
      this.perDiemImports = success.data || [];
      this.perDiemLoadingImports = false;
      this.perDiemImportsLoaded = true;
    }, () => {
      this.perDiemLoadingImports = false;
      this.perDiemImportsLoaded = true;
      this.toastr.error('Could not load per diem import history.', 'Error');
    });
  }

  onPerDiemFileSelected(input) {
    const file = input && input.files && input.files[0];
    this.$timeout(() => {
      this.perDiemSelectedFile = file || null;
      this.perDiemSelectedFileName = file ? file.name : '';
    });
  }

  uploadPerDiemRates() {
    if (!this.canManagePerDiemRates()) {
      this.toastr.warning('You do not have permission to import per diem rates.', 'Permission Denied');
      return;
    }
    if (!this.perDiemSelectedFile) {
      this.toastr.warning('Select a DoD CONUS or OCONUS ASCII ZIP (or .txt rate file) to upload.', 'File Required');
      return;
    }
    if (!this.perDiemSourceType) {
      this.toastr.warning('Select whether this file is CONUS or OCONUS.', 'Source Required');
      return;
    }

    const formData = new FormData();
    formData.append('file', this.perDiemSelectedFile);
    formData.append('sourceType', this.perDiemSourceType);
    if (this.perDiemNotes) {
      formData.append('notes', this.perDiemNotes);
    }

    this.perDiemUploading = true;
    this.$http.post(this.perDiemBaseUrl + '/imports', formData, {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
      transformRequest: angular.identity
    }).then((success) => {
      this.perDiemUploading = false;
      const imported = success.data || {};
      this.toastr.success(
        (imported.rowCount || 0) + ' rates imported from ' + (imported.filename || 'file') + '.',
        'Import Complete'
      );
      this.perDiemSelectedFile = null;
      this.perDiemSelectedFileName = '';
      this.perDiemNotes = '';
      const fileInput = document.getElementById('perDiemRateFile');
      if (fileInput) {
        fileInput.value = '';
      }
      this.loadPerDiemImports();
    }, (error) => {
      this.perDiemUploading = false;
      const message = (error.data && (error.data.detail || error.data.message || error.data.error))
        || error.statusText
        || 'Import failed.';
      this.toastr.error(message, 'Import Failed');
      this.loadPerDiemImports();
    });
  }

  onPerDiemLocationSelected(place) {
    if (!place) {
      return;
    }

    const components = this.extractPerDiemAddressComponents(place);
    this.perDiemSearch.city = components.city || '';
    this.perDiemSearch.state = components.state || '';
    this.perDiemSearch.country = components.country || '';
    this.perDiemSearch.zip = components.zip || '';
    this.perDiemSearch.place = place.formatted_address || place.name || this.perDiemLocationSearch || '';

    if (this.perDiemSearch.city || this.perDiemSearch.state || this.perDiemSearch.country) {
      this.searchPerDiemRates();
    } else {
      this.toastr.warning('Could not parse a city/state/country from that place.', 'Location Incomplete');
    }
  }

  extractPerDiemAddressComponents(place) {
    const result = {
      city: null,
      state: null,
      country: null,
      zip: null
    };

    if (!place || !place.address_components) {
      return result;
    }

    let locality = null;
    let postalTown = null;
    let adminArea2 = null;
    let adminArea1 = null;
    let country = null;
    let postal = null;

    place.address_components.forEach((component) => {
      const types = component.types || [];
      if (types.includes('locality')) {
        locality = component.long_name;
      }
      if (types.includes('postal_town')) {
        postalTown = component.long_name;
      }
      if (types.includes('administrative_area_level_2')) {
        adminArea2 = component.long_name;
      }
      if (types.includes('administrative_area_level_1')) {
        adminArea1 = component.short_name || component.long_name;
      }
      if (types.includes('country')) {
        country = component.short_name === 'US' ? 'UNITED STATES' : (component.long_name || component.short_name);
      }
      if (types.includes('postal_code')) {
        postal = component.short_name;
      }
    });

    result.city = locality || postalTown || adminArea2 || place.name || null;
    result.state = adminArea1;
    result.country = country;
    result.zip = postal ? String(postal).substring(0, 5) : null;
    return result;
  }

  searchPerDiemRates() {
    const params = {};
    if (this.perDiemSearch.city) {
      params.city = this.perDiemSearch.city;
    }
    if (this.perDiemSearch.state) {
      params.state = this.perDiemSearch.state;
    }
    if (this.perDiemSearch.country) {
      params.country = this.perDiemSearch.country;
    }
    if (!params.city && !params.state && !params.country) {
      this.toastr.warning('Select a destination from the search suggestions.', 'Search Required');
      return;
    }

    this.perDiemSearching = true;
    this.$http.get(this.perDiemBaseUrl + '/search', { params, withCredentials: true }).then((success) => {
      this.perDiemSearchResults = success.data || [];
      this.perDiemSearching = false;
      if (!this.perDiemSearchResults.length) {
        this.toastr.info('No matching rates found.', 'Search');
      }
    }, () => {
      this.perDiemSearching = false;
      this.toastr.error('Rate search failed.', 'Error');
    });
  }

  formatPerDiemMoney(value) {
    if (value == null || value === '') {
      return '—';
    }
    return '$' + Number(value).toFixed(2);
  }

  formatPerDiemDateTime(value) {
    if (!value) {
      return '—';
    }
    return moment(value).format('MM/DD/YYYY h:mm A');
  }

  getCompanyId() {
    return (this.company && this.company.id) ? this.company.id : 1;
  }

  loadIndirectRates() {
    if (!this.canViewCompanySettings()) {
      return;
    }

    let self = this;
    this.$http.get(this.$rootScope.apiHost + '/api/admin/companies/' + this.getCompanyId() + '/indirectrates', { withCredentials: true })
      .then(function (response) {
        self.indirectRates = response.data || [];
      }, function () {
        self.toastr.error('Could not load indirect rates.', 'ERROR');
      });
  }

  formatIndirectRateDate(date, showOpenWhenEmpty) {
    if (!date) {
      return showOpenWhenEmpty ? 'Open' : '—';
    }
    return moment(date).format('MMM DD, YYYY');
  }

  formatIndirectRatePercent(value) {
    if (value == null || value === '') {
      return '—';
    }
    return Number(value).toFixed(2) + '%';
  }

  getIndirectRateStatus(rate) {
    if (rate.current) {
      return 'Current';
    }

    const today = moment().startOf('day');
    const startDate = moment(rate.startDate);
    if (startDate.isAfter(today)) {
      return 'Future';
    }

    return 'Historical';
  }

  getIndirectRateStatusClass(rate) {
    const status = this.getIndirectRateStatus(rate);
    if (status === 'Current') {
      return 'label-success';
    }
    if (status === 'Future') {
      return 'label-info';
    }
    return 'label-default';
  }

  openIndirectRateModal(indirectRate) {
    let self = this;
    const modalInstance = this.$uibModal.open(indirectRateModal);
    modalInstance.isEdit = !!indirectRate;
    modalInstance.indirectRate = indirectRate || null;
    modalInstance.companyId = this.getCompanyId();
    modalInstance.existingIndirectRates = this.indirectRates || [];

    modalInstance.success = function () {
      self.toastr.success('Update Success', 'SUCCESS');
      self.loadIndirectRates();
      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  addIndirectRate() {
    this.openIndirectRateModal(null);
  }

  editIndirectRate(indirectRate) {
    this.openIndirectRateModal(indirectRate);
  }

  deleteIndirectRate(indirectRate) {
    if (indirectRate.inUse) {
      return;
    }

    let self = this;
    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = 'Delete Indirect Rate';
    modalInstance.subject = indirectRate.name;
    modalInstance.message = 'Delete this indirect rate table permanently?';

    modalInstance.yes = function () {
      modalInstance.dismiss();
      self.$http.delete(
        self.$rootScope.apiHost + '/api/admin/companies/' + self.getCompanyId() + '/indirectrates/' + indirectRate.id,
        { withCredentials: true }
      ).then(function () {
        self.toastr.success('Indirect rate deleted.', 'SUCCESS');
        self.loadIndirectRates();
      }, function (failure) {
        const message = failure.data && failure.data.message ? failure.data.message : 'Could not delete indirect rate.';
        self.toastr.error(message, 'ERROR');
      });
    };

    modalInstance.no = function () {
      modalInstance.dismiss();
    };
  }

  addDegree() {
    let self = this;
    var modalInstance = this.$uibModal.open(degreeModal);

    modalInstance.success = function () {
      self.toastr.success("Update Success", "SUCCESS");
      self.$http.get(self.$rootScope.apiHost+"/api/admin/companies/1/degrees", {withCredentials: true}).then(function (success) {
        self.companyDegrees = success.data;
      });
      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }


  updateAddress() {
    this.updateCompanyDetails('address', this.company.address);
    this.editAddress = false;
  }

  uploadFile() {
    this.fileObject.click();
  }

  updateCompanyDetails(parameter, value) {
    let self = this;
    const originalValue = this.originalCompany ? this.originalCompany[parameter] : this.company[parameter];
    if (angular.equals(originalValue, value)) {
      return;
    }

    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/companies/"+this.company.id, obj, {withCredentials: true}).then(function (success) {
      self.originalCompany[parameter] = value;
      self.employee = success.data;
      self.toastr.success("Company Update Successfully.", "Success!");

    }, function (failure) {
      self.company[parameter] = originalValue;
      self.toastr.error("Could not update Company Setting.", "ERROR");
    });
  }

  getLogoUrl() {
    if (!this.logoUrl) {
      return null;
    }
    // Append timestamp for cache busting
    const separator = this.logoUrl.includes('?') ? '&' : '?';
    return this.logoUrl + separator + this.$rootScope.logoPicTimeStamp;
  }

  loadLogoUrl() {
    let self = this;
    if (!this.company || !this.company.id) {
      this.logoLoading = false;
      return;
    }
    const logoUrl = this.$rootScope.apiHost+"/api/admin/companies/"+this.company.id+"/logo";
    this.logoLoading = true;
    
    // Test the URL with a GET request to check if it exists
    this.$http.get(logoUrl, {withCredentials: true})
      .then(function(response) {
        // Success - logo exists
        self.logoExists = true;
        self.logoUrl = logoUrl;
        self.logoLoading = false;
      })
      .catch(function(error) {
        // 404 or other error - logo doesn't exist
        if (error.status === 404) {
          self.logoExists = false;
          self.logoUrl = null;
        } else {
          // Other error - assume it doesn't exist for now
          self.logoExists = false;
          self.logoUrl = null;
        }
        self.logoLoading = false;
      });
  }

  resetLogoPath() {
    this.newLogoPic = null;
  }

  setPath() {
    console.log('setting path');
    let url = URL.createObjectURL(this.fileObject.files[0]);
    document.getElementById("companyLogo").src = url;
    this.newLogoPic = url;
    this.$scope.$apply();
  }


  updateLogo() {
    let logoPic = this.fileObject.files[0];

    let config = {
      headers: {
        'Content-Type': undefined
      },
      withCredentials: true,
      transformRequest: angular.identity
    };

    let self = this;

    var fd = new FormData();
    fd.append('file', logoPic);
    return this.$http.post(this.$rootScope.apiHost+"/api/admin/companies/"+this.company.id+"/logo", fd, config).then(function (success) {
        self.toastr.success("Your company logo was updated successfully.", "Logo Updated!");
        // Update timestamp to force refresh
        self.$rootScope.logoPicTimeStamp = (new Date()).getTime();
        // Reload logo URL to check if it exists
        self.loadLogoUrl();
        // Broadcast event to refresh logo in header component
        self.$rootScope.$broadcast('logoUpdated');
    }, function (failure) {

    });
  }


  selectUser(x) {
    this.userId = x.id;
  }

  selectOldChargeCode(x) {
    this.oldChargeCode = x;
  }

  selectNewChargeCode(x) {
    this.newChargeCode = x;
  }

  bulkUpdateChargeCode() {
    this.fromDate = moment(this.fromDate).format('YYYY-MM-DD');
    this.endDate = moment(this.endDate).format('YYYY-MM-DD');

    let params = {
      userId: this.userId,
      fromDate: this.fromDate,
      toDate: this.endDate,
      oldChargeCode: this.oldChargeCode,
      newChargeCode: this.newChargeCode
    }

    let self = this;
    this.$http.post(this.$rootScope.apiHost+ "/api/admin/chargecodes/bulkchange?userId="+this.userId+"&fromDate="+this.fromDate+"&toDate="+this.endDate+"&oldChargeCode="+this.oldChargeCode.id+"&newChargeCode="+this.newChargeCode.id, params, {withCredentials: true}).then(function (success) {
      self.toastr.success("Successfully updated " + success.data.data + " Time Entries.", "SUCCESS");
      self.userId = undefined;
      self.fromDate = undefined;
      self.selectedUser = undefined;
      self.toDate = undefined;
      self.oldChargeCode = undefined;
      self.newChargeCode = undefined;
    });

  }


}

export default SettingsController;



// WEBPACK FOOTER //
// ./client/pages/admin/settings/settings.controller.js